import React from 'react';
import styled, { css } from 'styled-components';

export type BadgeVariant = 'live' | 'coming-soon';

const StyledBadge = styled.span<{ $variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.3rem 0.7rem;
  border-radius: var(--radius-pill);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.02em;
  white-space: nowrap;

  ${({ $variant }) =>
    $variant === 'live'
      ? css`
          color: var(--text-1);
          background: rgba(192, 204, 48, 0.1);
          border: 1px solid rgba(192, 204, 48, 0.32);

          &::before {
            content: '';
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: var(--lime-500);
            box-shadow: 0 0 0 3px rgba(192, 204, 48, 0.18);
          }
        `
      : css`
          color: var(--slate-300);
          background: transparent;
          border: 1px solid var(--slate-500);
        `}
`;

const LABELS: Record<BadgeVariant, string> = {
  live: 'Live',
  'coming-soon': 'Coming soon',
};

interface BadgeProps {
  variant: BadgeVariant;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ variant, className }) => (
  <StyledBadge $variant={variant} className={className}>
    {LABELS[variant]}
  </StyledBadge>
);

export default Badge;
